// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard - Keka HR Inspired Design */

/* ===== Base & Background ===== */
.keka-dashboard {
  background: #f0f4f8;
  min-height: calc(100vh - 140px);
}

/* ===== Loading Spinner ===== */
.loading-spinner {
  width: 44px;
  height: 44px;
  border: 3px solid #e2e8f0;
  border-radius: 50%;
  border-top-color: #667eea;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* ===== Hero Welcome Banner ===== */
@keyframes heroGradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

.hero-banner {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 40%, #667eea 70%, #764ba2 100%);
  background-size: 200% 200%;
  animation: heroGradientShift 12s ease infinite;
  border-radius: 20px;
  padding: 32px 36px;
  min-height: 130px;
  position: relative;
  overflow: hidden;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  box-shadow: 0 8px 32px rgba(30, 60, 114, 0.25);
}

.hero-banner::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -20%;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.hero-banner::after {
  content: "";
  position: absolute;
  bottom: -30%;
  left: -10%;
  width: 300px;
  height: 300px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.05) 0%, transparent 70%);
  border-radius: 50%;
  pointer-events: none;
}

.hero-left {
  display: flex;
  align-items: center;
  gap: 20px;
  z-index: 1;
  flex: 1 1;
  min-width: 0;
}

.hero-text-block {
  min-width: 0;
}

.hero-highlights {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}

.hero-highlight {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border-radius: 999px;
  font-size: 0.8125rem;
  font-weight: 600;
  line-height: 1.3;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.28);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.hero-highlight svg {
  font-size: 0.875rem;
  opacity: 0.95;
}

.hero-highlight-holiday {
  background: rgba(59, 130, 246, 0.35);
}

.hero-highlight-birthday {
  background: rgba(245, 158, 11, 0.38);
}

.hero-avatar {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.5);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  object-fit: cover;
  flex-shrink: 0;
}

.hero-greeting {
  font-size: 1.75rem;
  font-weight: 700;
  color: #fff;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.hero-subtitle {
  font-size: 0.9375rem;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 4px;
}

.hero-right {
  display: flex;
  gap: 12px;
  align-items: center;
  z-index: 1;
}

.hero-chip {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 8px 16px;
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 500;
  white-space: nowrap;
}

.hero-chip svg {
  opacity: 0.8;
}

/* ===== Gradient Stat Cards ===== */
.stat-card-gradient {
  border-radius: 16px;
  padding: 24px;
  color: #fff;
  position: relative;
  overflow: hidden;
  min-height: 110px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: default;
}

.stat-card-gradient:hover {
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);
}

.stat-card-gradient::after {
  content: "";
  position: absolute;
  top: -20px;
  right: -20px;
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  pointer-events: none;
}

.stat-card-gradient .stat-icon {
  position: absolute;
  top: 16px;
  right: 18px;
  font-size: 22px;
  opacity: 0.4;
}

.stat-card-gradient .stat-number {
  font-size: 2.25rem;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.03em;
}

.stat-card-gradient .stat-label {
  font-size: 0.8125rem;
  font-weight: 500;
  opacity: 0.85;
  margin-top: 6px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.stat-present {
  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
}
.stat-absent {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}
.stat-halfday {
  background: linear-gradient(135deg, #fccb90 0%, #d57eeb 100%);
}
.stat-leave {
  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
}

/* ===== Quick Action Buttons (App-Icon Style) ===== */
.quick-actions-row {
  display: flex;
  gap: 16px;
  margin-bottom: 28px;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.quick-action-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.25s ease;
  min-width: 72px;
}

.quick-action-item:hover {
  transform: translateY(-3px);
}

.quick-action-item:hover .quick-action-circle {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);
  transform: scale(1.08);
}

.quick-action-circle {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #fff;
  transition: all 0.25s ease;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);
}

.quick-action-label {
  font-size: 0.6875rem;
  font-weight: 500;
  color: #475569;
  text-align: center;
  line-height: 1.3;
  max-width: 80px;
}

/* Quick action color variants */
.qa-blue { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }
.qa-green { background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%); }
.qa-orange { background: linear-gradient(135deg, #f7971e 0%, #ffd200 100%); }
.qa-purple { background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%); }
.qa-teal { background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); }
.qa-red { background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%); }
.qa-indigo { background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%); }

/* ===== White Content Cards ===== */
.keka-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  padding: 24px;
  height: 100%;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.04);
}

.keka-card:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
}

.keka-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.keka-card-title {
  font-size: 1rem;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.01em;
}

/* ===== Profile Card ===== */
.profile-card-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f1f5f9;
  margin-bottom: 20px;
}

.profile-avatar-ring {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  padding: 3px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  flex-shrink: 0;
}

.profile-avatar-ring img,
.profile-avatar-ring .MuiAvatar-root {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid #fff;
}

.profile-name {
  font-size: 1.125rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
}

.profile-role-badge {
  display: inline-block;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  font-size: 0.6875rem;
  font-weight: 600;
  padding: 3px 12px;
  border-radius: 20px;
  margin-top: 4px;
  letter-spacing: 0.02em;
}

.profile-id {
  font-size: 0.75rem;
  color: #94a3b8;
  margin-top: 3px;
}

.profile-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.profile-info-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.profile-info-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.6875rem;
  color: #94a3b8;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.profile-info-label svg {
  font-size: 11px;
}

.profile-info-value {
  font-size: 0.8125rem;
  color: #1e293b;
  font-weight: 500;
  padding-left: 17px;
  word-break: break-word;
}

/* ===== Attendance Chart Card ===== */
.attendance-chart-wrapper {
  display: flex;
  align-items: center;
  gap: 32px;
  flex: 1 1;
}

.donut-container {
  width: 160px;
  height: 160px;
  position: relative;
  flex-shrink: 0;
}

.donut-center-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
  width: 80px;
}

.donut-center-percent {
  font-weight: 800;
  font-size: 1rem;
  color: #0f172a;
  line-height: 1.2;
}

.donut-center-label {
  font-size: 0.5625rem;
  color: #64748b;
  font-weight: 500;
}

.legend-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #f1f5f9;
}

.legend-item:last-child {
  border-bottom: none;
}

.legend-dot {
  width: 12px;
  height: 12px;
  border-radius: 4px;
  flex-shrink: 0;
}

.legend-label {
  font-size: 0.8125rem;
  color: #64748b;
  margin-left: 12px;
}

.legend-count {
  font-weight: 700;
  font-size: 0.875rem;
  color: #0f172a;
}

/* Today's Status */
.today-status-box {
  margin-top: 16px;
  padding: 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, #f0f4f8 0%, #e8edf5 100%);
  border: 1px solid #e2e8f0;
}

.today-status-label {
  font-size: 0.6875rem;
  color: #64748b;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 10px;
}

.today-status-grid {
  display: flex;
  gap: 24px;
}

.today-status-item-label {
  font-size: 0.6875rem;
  color: #94a3b8;
  margin-bottom: 2px;
}

.today-status-item-value {
  font-size: 0.875rem;
  font-weight: 700;
}

/* No attendance warning */
.no-attendance-box {
  margin-top: 16px;
  padding: 16px 20px;
  border-radius: 12px;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 1px solid #fbbf24;
}

.no-attendance-text {
  font-size: 0.8125rem;
  color: #92400e;
  font-weight: 600;
}

.mark-attendance-btn {
  margin-top: 10px;
  padding: 8px 20px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #059669 0%, #34d399 100%);
  color: #fff;
  font-weight: 600;
  font-size: 0.8125rem;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 14px rgba(5, 150, 105, 0.3);
}

.mark-attendance-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);
}

/* ===== Bottom Cards - Accent Borders ===== */
.accent-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  padding: 24px;
  height: 100%;
  border-left: 4px solid transparent;
  transition: all 0.3s ease;
  border-top: none;
  border-right: none;
  border-bottom: none;
}

.accent-card:hover {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.accent-card-blue {
  border-left-color: #4facfe;
}

.accent-card-pink {
  border-left-color: #f093fb;
}

.accent-card-orange {
  border-left-color: #f7971e;
}

/* Holiday item */
.holiday-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.holiday-item:hover {
  background: #f0f4f8;
  border-color: #e2e8f0;
}

.holiday-icon-circle {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.holiday-icon-blue {
  background: linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%);
  color: #3b82f6;
}

.holiday-name {
  font-weight: 600;
  font-size: 0.875rem;
  color: #0f172a;
}

.holiday-date {
  font-size: 0.75rem;
  color: #64748b;
  margin-top: 2px;
}

/* Birthday item */
.birthday-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.birthday-item:hover {
  background: #fdf2f8;
  border-color: #fce7f3;
}

.birthday-icon-circle {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  flex-shrink: 0;
  background: linear-gradient(135deg, #fce7f3 0%, #fce4ec 100%);
  color: #ec4899;
}

.birthday-name {
  font-weight: 600;
  font-size: 0.8125rem;
  color: #0f172a;
}

.birthday-date {
  font-size: 0.6875rem;
  color: #64748b;
}

.birthday-today-badge {
  color: #059669;
  font-weight: 700;
  margin-left: 6px;
  font-size: 0.6875rem;
}

/* Leave request item */
.leave-request-item {
  padding: 14px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.leave-request-item:hover {
  background: #fff7ed;
  border-color: #fed7aa;
}

.leave-request-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.leave-request-name {
  font-weight: 600;
  font-size: 0.8125rem;
  color: #0f172a;
}

.leave-request-dates {
  font-size: 0.6875rem;
  color: #64748b;
}

.leave-request-reason {
  font-size: 0.6875rem;
  color: #94a3b8;
  margin-top: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ===== View All / See All buttons ===== */
.view-all-btn {
  background: none;
  border: none;
  color: #667eea;
  font-weight: 600;
  font-size: 0.75rem;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.view-all-btn:hover {
  background: #eef2ff;
  color: #4f46e5;
}

/* ===== View Details button ===== */
.view-details-btn {
  background: none;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-weight: 500;
  font-size: 0.75rem;
  cursor: pointer;
  padding: 6px 14px;
  border-radius: 10px;
  transition: all 0.2s ease;
}

.view-details-btn:hover {
  border-color: #667eea;
  color: #667eea;
  background: #eef2ff;
}

/* ===== Empty State ===== */
.empty-state {
  font-size: 0.8125rem;
  color: #94a3b8;
  text-align: center;
  padding: 32px 0;
}

/* ===== ID Card Modal Keka Styling ===== */
.idcard-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(4px);
}

.idcard-modal-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
  border-radius: 16px;
}

.idcard-close-btn {
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(8px);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.idcard-close-btn:hover {
  background: rgba(220, 38, 38, 0.9);
}

/* ===== Responsive ===== */
@media (max-width: 960px) {
  .hero-banner {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    padding: 24px;
    min-height: auto;
  }

  .hero-right {
    width: 100%;
    justify-content: flex-start;
  }

  .hero-greeting {
    font-size: 1.4rem;
  }

  .attendance-chart-wrapper {
    flex-direction: column;
    align-items: center;
  }

  .profile-info-grid {
    grid-template-columns: 1fr;
  }

  .quick-actions-row {
    overflow-x: auto;
    flex-wrap: nowrap;
    padding-bottom: 8px;
    -webkit-overflow-scrolling: touch;
  }

  .quick-actions-row::-webkit-scrollbar {
    display: none;
  }
}

@media (max-width: 600px) {
  .hero-banner {
    padding: 16px;
    border-radius: 14px;
    min-height: auto;
    margin-bottom: 16px;
  }

  .hero-avatar {
    width: 44px;
    height: 44px;
  }

  .hero-left {
    gap: 12px;
  }

  .hero-greeting {
    font-size: 1.1rem;
  }

  .hero-subtitle {
    font-size: 0.8rem;
    margin-top: 2px;
  }

  .hero-chip {
    display: none;
  }

  .hero-right {
    display: none;
  }

  .stat-card-gradient {
    padding: 14px;
    min-height: 80px;
    border-radius: 12px;
  }

  .stat-card-gradient .stat-number {
    font-size: 1.5rem;
  }

  .stat-card-gradient .stat-label {
    font-size: 0.7rem;
    margin-top: 4px;
  }

  .stat-card-gradient .stat-icon {
    font-size: 18px;
    top: 12px;
    right: 14px;
  }

  .quick-actions-row {
    overflow-x: auto;
    flex-wrap: nowrap;
    gap: 10px;
    margin-bottom: 16px;
    padding-bottom: 8px;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .quick-actions-row::-webkit-scrollbar {
    display: none;
  }

  .quick-action-circle {
    width: 44px;
    height: 44px;
    font-size: 16px;
    border-radius: 12px;
  }

  .quick-action-item {
    min-width: 60px;
    gap: 6px;
  }

  .quick-action-label {
    font-size: 0.6rem;
    max-width: 64px;
  }

  .keka-card {
    padding: 16px;
    border-radius: 12px;
  }

  .accent-card {
    padding: 16px;
    border-radius: 12px;
  }

  .keka-card-header {
    margin-bottom: 14px;
  }

  .keka-card-title {
    font-size: 0.875rem;
  }

  .profile-card-header {
    gap: 12px;
    padding-bottom: 14px;
    margin-bottom: 14px;
  }

  .profile-avatar-ring {
    width: 52px;
    height: 52px;
  }

  .profile-name {
    font-size: 1rem;
  }

  .profile-info-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .profile-info-value {
    font-size: 0.75rem;
  }

  .attendance-chart-wrapper {
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .donut-container {
    width: 120px;
    height: 120px;
  }

  .donut-center-text {
    width: 60px;
  }

  .donut-center-percent {
    font-size: 0.875rem;
  }

  .donut-center-label {
    font-size: 0.5rem;
  }

  .legend-item {
    padding: 8px 0;
  }

  .legend-label {
    font-size: 0.75rem;
    margin-left: 8px;
  }

  .legend-count {
    font-size: 0.8rem;
  }

  .today-status-box {
    margin-top: 12px;
    padding: 12px;
  }

  .today-status-grid {
    gap: 14px;
    flex-wrap: wrap;
  }

  .holiday-item {
    padding: 10px;
    gap: 10px;
  }

  .holiday-icon-circle {
    width: 38px;
    height: 38px;
    font-size: 15px;
  }

  .holiday-name {
    font-size: 0.8rem;
  }

  .birthday-item {
    padding: 10px;
    gap: 10px;
  }

  .birthday-icon-circle {
    width: 34px;
    height: 34px;
    font-size: 13px;
  }

  .leave-request-item {
    padding: 10px;
  }

  .no-attendance-box {
    padding: 12px 14px;
  }

  .empty-state {
    padding: 20px 0;
    font-size: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC,kCAAkC;AAClC;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA,gCAAgC;AAChC;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,uFAAuF;EACvF,0BAA0B;EAC1B,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kFAAkF;EAClF,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,aAAa;EACb,kFAAkF;EAClF,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,SAAO;EACP,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,2CAA2C;EAC3C,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0CAA0C;EAC1C,yCAAyC;EACzC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,0CAA0C;EAC1C,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;AACA;EACE,6DAA6D;AAC/D;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,gCAAgC;AAChC,WAAW,6DAA6D,EAAE;AAC1E,YAAY,6DAA6D,EAAE;AAC3E,aAAa,6DAA6D,EAAE;AAC5E,aAAa,6DAA6D,EAAE;AAC5E,WAAW,6DAA6D,EAAE;AAC1E,UAAU,6DAA6D,EAAE;AACzE,aAAa,6DAA6D,EAAE;;AAE5E,oCAAoC;AACpC;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,YAAY;EACZ,kCAAkC;EAClC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,oCAAoC;EACpC,0BAA0B;EAC1B,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,SAAS;IACT,WAAW;EACb;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;IACnB,iCAAiC;IACjC,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;AACF","sourcesContent":["/* Dashboard - Keka HR Inspired Design */\n\n/* ===== Base & Background ===== */\n.keka-dashboard {\n  background: #f0f4f8;\n  min-height: calc(100vh - 140px);\n}\n\n/* ===== Loading Spinner ===== */\n.loading-spinner {\n  width: 44px;\n  height: 44px;\n  border: 3px solid #e2e8f0;\n  border-radius: 50%;\n  border-top-color: #667eea;\n  animation: spin 0.8s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ===== Hero Welcome Banner ===== */\n@keyframes heroGradientShift {\n  0% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n.hero-banner {\n  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 40%, #667eea 70%, #764ba2 100%);\n  background-size: 200% 200%;\n  animation: heroGradientShift 12s ease infinite;\n  border-radius: 20px;\n  padding: 32px 36px;\n  min-height: 130px;\n  position: relative;\n  overflow: hidden;\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n  box-shadow: 0 8px 32px rgba(30, 60, 114, 0.25);\n}\n\n.hero-banner::before {\n  content: \"\";\n  position: absolute;\n  top: -50%;\n  right: -20%;\n  width: 400px;\n  height: 400px;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, transparent 70%);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.hero-banner::after {\n  content: \"\";\n  position: absolute;\n  bottom: -30%;\n  left: -10%;\n  width: 300px;\n  height: 300px;\n  background: radial-gradient(circle, rgba(255, 255, 255, 0.05) 0%, transparent 70%);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.hero-left {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  z-index: 1;\n  flex: 1;\n  min-width: 0;\n}\n\n.hero-text-block {\n  min-width: 0;\n}\n\n.hero-highlights {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.hero-highlight {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 14px;\n  border-radius: 999px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  line-height: 1.3;\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.hero-highlight svg {\n  font-size: 0.875rem;\n  opacity: 0.95;\n}\n\n.hero-highlight-holiday {\n  background: rgba(59, 130, 246, 0.35);\n}\n\n.hero-highlight-birthday {\n  background: rgba(245, 158, 11, 0.38);\n}\n\n.hero-avatar {\n  width: 68px;\n  height: 68px;\n  border-radius: 50%;\n  border: 3px solid rgba(255, 255, 255, 0.5);\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.hero-greeting {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #fff;\n  margin: 0;\n  line-height: 1.3;\n  letter-spacing: -0.02em;\n}\n\n.hero-subtitle {\n  font-size: 0.9375rem;\n  color: rgba(255, 255, 255, 0.7);\n  margin-top: 4px;\n}\n\n.hero-right {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  z-index: 1;\n}\n\n.hero-chip {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.15);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 12px;\n  padding: 8px 16px;\n  color: #fff;\n  font-size: 0.8125rem;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.hero-chip svg {\n  opacity: 0.8;\n}\n\n/* ===== Gradient Stat Cards ===== */\n.stat-card-gradient {\n  border-radius: 16px;\n  padding: 24px;\n  color: #fff;\n  position: relative;\n  overflow: hidden;\n  min-height: 110px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  cursor: default;\n}\n\n.stat-card-gradient:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.18);\n}\n\n.stat-card-gradient::after {\n  content: \"\";\n  position: absolute;\n  top: -20px;\n  right: -20px;\n  width: 80px;\n  height: 80px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n  pointer-events: none;\n}\n\n.stat-card-gradient .stat-icon {\n  position: absolute;\n  top: 16px;\n  right: 18px;\n  font-size: 22px;\n  opacity: 0.4;\n}\n\n.stat-card-gradient .stat-number {\n  font-size: 2.25rem;\n  font-weight: 800;\n  line-height: 1;\n  letter-spacing: -0.03em;\n}\n\n.stat-card-gradient .stat-label {\n  font-size: 0.8125rem;\n  font-weight: 500;\n  opacity: 0.85;\n  margin-top: 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.stat-present {\n  background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);\n}\n.stat-absent {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n}\n.stat-halfday {\n  background: linear-gradient(135deg, #fccb90 0%, #d57eeb 100%);\n}\n.stat-leave {\n  background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);\n}\n\n/* ===== Quick Action Buttons (App-Icon Style) ===== */\n.quick-actions-row {\n  display: flex;\n  gap: 16px;\n  margin-bottom: 28px;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n}\n\n.quick-action-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: all 0.25s ease;\n  min-width: 72px;\n}\n\n.quick-action-item:hover {\n  transform: translateY(-3px);\n}\n\n.quick-action-item:hover .quick-action-circle {\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.18);\n  transform: scale(1.08);\n}\n\n.quick-action-circle {\n  width: 56px;\n  height: 56px;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  color: #fff;\n  transition: all 0.25s ease;\n  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.12);\n}\n\n.quick-action-label {\n  font-size: 0.6875rem;\n  font-weight: 500;\n  color: #475569;\n  text-align: center;\n  line-height: 1.3;\n  max-width: 80px;\n}\n\n/* Quick action color variants */\n.qa-blue { background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); }\n.qa-green { background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%); }\n.qa-orange { background: linear-gradient(135deg, #f7971e 0%, #ffd200 100%); }\n.qa-purple { background: linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%); }\n.qa-teal { background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%); }\n.qa-red { background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%); }\n.qa-indigo { background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%); }\n\n/* ===== White Content Cards ===== */\n.keka-card {\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n  padding: 24px;\n  height: 100%;\n  transition: all 0.3s ease;\n  border: 1px solid rgba(0, 0, 0, 0.04);\n}\n\n.keka-card:hover {\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);\n}\n\n.keka-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.keka-card-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #1e293b;\n  letter-spacing: -0.01em;\n}\n\n/* ===== Profile Card ===== */\n.profile-card-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid #f1f5f9;\n  margin-bottom: 20px;\n}\n\n.profile-avatar-ring {\n  width: 68px;\n  height: 68px;\n  border-radius: 50%;\n  padding: 3px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  flex-shrink: 0;\n}\n\n.profile-avatar-ring img,\n.profile-avatar-ring .MuiAvatar-root {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 3px solid #fff;\n}\n\n.profile-name {\n  font-size: 1.125rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.01em;\n}\n\n.profile-role-badge {\n  display: inline-block;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: #fff;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  padding: 3px 12px;\n  border-radius: 20px;\n  margin-top: 4px;\n  letter-spacing: 0.02em;\n}\n\n.profile-id {\n  font-size: 0.75rem;\n  color: #94a3b8;\n  margin-top: 3px;\n}\n\n.profile-info-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.profile-info-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.profile-info-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.6875rem;\n  color: #94a3b8;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n\n.profile-info-label svg {\n  font-size: 11px;\n}\n\n.profile-info-value {\n  font-size: 0.8125rem;\n  color: #1e293b;\n  font-weight: 500;\n  padding-left: 17px;\n  word-break: break-word;\n}\n\n/* ===== Attendance Chart Card ===== */\n.attendance-chart-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  flex: 1;\n}\n\n.donut-container {\n  width: 160px;\n  height: 160px;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.donut-center-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  pointer-events: none;\n  width: 80px;\n}\n\n.donut-center-percent {\n  font-weight: 800;\n  font-size: 1rem;\n  color: #0f172a;\n  line-height: 1.2;\n}\n\n.donut-center-label {\n  font-size: 0.5625rem;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.legend-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.legend-item:last-child {\n  border-bottom: none;\n}\n\n.legend-dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 4px;\n  flex-shrink: 0;\n}\n\n.legend-label {\n  font-size: 0.8125rem;\n  color: #64748b;\n  margin-left: 12px;\n}\n\n.legend-count {\n  font-weight: 700;\n  font-size: 0.875rem;\n  color: #0f172a;\n}\n\n/* Today's Status */\n.today-status-box {\n  margin-top: 16px;\n  padding: 16px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #f0f4f8 0%, #e8edf5 100%);\n  border: 1px solid #e2e8f0;\n}\n\n.today-status-label {\n  font-size: 0.6875rem;\n  color: #64748b;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-bottom: 10px;\n}\n\n.today-status-grid {\n  display: flex;\n  gap: 24px;\n}\n\n.today-status-item-label {\n  font-size: 0.6875rem;\n  color: #94a3b8;\n  margin-bottom: 2px;\n}\n\n.today-status-item-value {\n  font-size: 0.875rem;\n  font-weight: 700;\n}\n\n/* No attendance warning */\n.no-attendance-box {\n  margin-top: 16px;\n  padding: 16px 20px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  border: 1px solid #fbbf24;\n}\n\n.no-attendance-text {\n  font-size: 0.8125rem;\n  color: #92400e;\n  font-weight: 600;\n}\n\n.mark-attendance-btn {\n  margin-top: 10px;\n  padding: 8px 20px;\n  border: none;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #059669 0%, #34d399 100%);\n  color: #fff;\n  font-weight: 600;\n  font-size: 0.8125rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  box-shadow: 0 4px 14px rgba(5, 150, 105, 0.3);\n}\n\n.mark-attendance-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(5, 150, 105, 0.4);\n}\n\n/* ===== Bottom Cards - Accent Borders ===== */\n.accent-card {\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);\n  padding: 24px;\n  height: 100%;\n  border-left: 4px solid transparent;\n  transition: all 0.3s ease;\n  border-top: none;\n  border-right: none;\n  border-bottom: none;\n}\n\n.accent-card:hover {\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);\n  transform: translateY(-2px);\n}\n\n.accent-card-blue {\n  border-left-color: #4facfe;\n}\n\n.accent-card-pink {\n  border-left-color: #f093fb;\n}\n\n.accent-card-orange {\n  border-left-color: #f7971e;\n}\n\n/* Holiday item */\n.holiday-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 14px;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n}\n\n.holiday-item:hover {\n  background: #f0f4f8;\n  border-color: #e2e8f0;\n}\n\n.holiday-icon-circle {\n  width: 46px;\n  height: 46px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.holiday-icon-blue {\n  background: linear-gradient(135deg, #dbeafe 0%, #e0e7ff 100%);\n  color: #3b82f6;\n}\n\n.holiday-name {\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: #0f172a;\n}\n\n.holiday-date {\n  font-size: 0.75rem;\n  color: #64748b;\n  margin-top: 2px;\n}\n\n/* Birthday item */\n.birthday-item {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 14px;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n}\n\n.birthday-item:hover {\n  background: #fdf2f8;\n  border-color: #fce7f3;\n}\n\n.birthday-icon-circle {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  flex-shrink: 0;\n  background: linear-gradient(135deg, #fce7f3 0%, #fce4ec 100%);\n  color: #ec4899;\n}\n\n.birthday-name {\n  font-weight: 600;\n  font-size: 0.8125rem;\n  color: #0f172a;\n}\n\n.birthday-date {\n  font-size: 0.6875rem;\n  color: #64748b;\n}\n\n.birthday-today-badge {\n  color: #059669;\n  font-weight: 700;\n  margin-left: 6px;\n  font-size: 0.6875rem;\n}\n\n/* Leave request item */\n.leave-request-item {\n  padding: 14px;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n}\n\n.leave-request-item:hover {\n  background: #fff7ed;\n  border-color: #fed7aa;\n}\n\n.leave-request-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n}\n\n.leave-request-name {\n  font-weight: 600;\n  font-size: 0.8125rem;\n  color: #0f172a;\n}\n\n.leave-request-dates {\n  font-size: 0.6875rem;\n  color: #64748b;\n}\n\n.leave-request-reason {\n  font-size: 0.6875rem;\n  color: #94a3b8;\n  margin-top: 4px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* ===== View All / See All buttons ===== */\n.view-all-btn {\n  background: none;\n  border: none;\n  color: #667eea;\n  font-weight: 600;\n  font-size: 0.75rem;\n  cursor: pointer;\n  padding: 4px 8px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.view-all-btn:hover {\n  background: #eef2ff;\n  color: #4f46e5;\n}\n\n/* ===== View Details button ===== */\n.view-details-btn {\n  background: none;\n  border: 1px solid #e2e8f0;\n  color: #475569;\n  font-weight: 500;\n  font-size: 0.75rem;\n  cursor: pointer;\n  padding: 6px 14px;\n  border-radius: 10px;\n  transition: all 0.2s ease;\n}\n\n.view-details-btn:hover {\n  border-color: #667eea;\n  color: #667eea;\n  background: #eef2ff;\n}\n\n/* ===== Empty State ===== */\n.empty-state {\n  font-size: 0.8125rem;\n  color: #94a3b8;\n  text-align: center;\n  padding: 32px 0;\n}\n\n/* ===== ID Card Modal Keka Styling ===== */\n.idcard-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  backdrop-filter: blur(4px);\n}\n\n.idcard-modal-content {\n  position: relative;\n  max-width: 90%;\n  max-height: 90%;\n  border-radius: 16px;\n}\n\n.idcard-close-btn {\n  position: absolute;\n  right: 10px;\n  top: 10px;\n  z-index: 1;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(8px);\n  color: #fff;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.idcard-close-btn:hover {\n  background: rgba(220, 38, 38, 0.9);\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 960px) {\n  .hero-banner {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n    padding: 24px;\n    min-height: auto;\n  }\n\n  .hero-right {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .hero-greeting {\n    font-size: 1.4rem;\n  }\n\n  .attendance-chart-wrapper {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .profile-info-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .quick-actions-row {\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    padding-bottom: 8px;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .quick-actions-row::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n@media (max-width: 600px) {\n  .hero-banner {\n    padding: 16px;\n    border-radius: 14px;\n    min-height: auto;\n    margin-bottom: 16px;\n  }\n\n  .hero-avatar {\n    width: 44px;\n    height: 44px;\n  }\n\n  .hero-left {\n    gap: 12px;\n  }\n\n  .hero-greeting {\n    font-size: 1.1rem;\n  }\n\n  .hero-subtitle {\n    font-size: 0.8rem;\n    margin-top: 2px;\n  }\n\n  .hero-chip {\n    display: none;\n  }\n\n  .hero-right {\n    display: none;\n  }\n\n  .stat-card-gradient {\n    padding: 14px;\n    min-height: 80px;\n    border-radius: 12px;\n  }\n\n  .stat-card-gradient .stat-number {\n    font-size: 1.5rem;\n  }\n\n  .stat-card-gradient .stat-label {\n    font-size: 0.7rem;\n    margin-top: 4px;\n  }\n\n  .stat-card-gradient .stat-icon {\n    font-size: 18px;\n    top: 12px;\n    right: 14px;\n  }\n\n  .quick-actions-row {\n    overflow-x: auto;\n    flex-wrap: nowrap;\n    gap: 10px;\n    margin-bottom: 16px;\n    padding-bottom: 8px;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .quick-actions-row::-webkit-scrollbar {\n    display: none;\n  }\n\n  .quick-action-circle {\n    width: 44px;\n    height: 44px;\n    font-size: 16px;\n    border-radius: 12px;\n  }\n\n  .quick-action-item {\n    min-width: 60px;\n    gap: 6px;\n  }\n\n  .quick-action-label {\n    font-size: 0.6rem;\n    max-width: 64px;\n  }\n\n  .keka-card {\n    padding: 16px;\n    border-radius: 12px;\n  }\n\n  .accent-card {\n    padding: 16px;\n    border-radius: 12px;\n  }\n\n  .keka-card-header {\n    margin-bottom: 14px;\n  }\n\n  .keka-card-title {\n    font-size: 0.875rem;\n  }\n\n  .profile-card-header {\n    gap: 12px;\n    padding-bottom: 14px;\n    margin-bottom: 14px;\n  }\n\n  .profile-avatar-ring {\n    width: 52px;\n    height: 52px;\n  }\n\n  .profile-name {\n    font-size: 1rem;\n  }\n\n  .profile-info-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n\n  .profile-info-value {\n    font-size: 0.75rem;\n  }\n\n  .attendance-chart-wrapper {\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n  }\n\n  .donut-container {\n    width: 120px;\n    height: 120px;\n  }\n\n  .donut-center-text {\n    width: 60px;\n  }\n\n  .donut-center-percent {\n    font-size: 0.875rem;\n  }\n\n  .donut-center-label {\n    font-size: 0.5rem;\n  }\n\n  .legend-item {\n    padding: 8px 0;\n  }\n\n  .legend-label {\n    font-size: 0.75rem;\n    margin-left: 8px;\n  }\n\n  .legend-count {\n    font-size: 0.8rem;\n  }\n\n  .today-status-box {\n    margin-top: 12px;\n    padding: 12px;\n  }\n\n  .today-status-grid {\n    gap: 14px;\n    flex-wrap: wrap;\n  }\n\n  .holiday-item {\n    padding: 10px;\n    gap: 10px;\n  }\n\n  .holiday-icon-circle {\n    width: 38px;\n    height: 38px;\n    font-size: 15px;\n  }\n\n  .holiday-name {\n    font-size: 0.8rem;\n  }\n\n  .birthday-item {\n    padding: 10px;\n    gap: 10px;\n  }\n\n  .birthday-icon-circle {\n    width: 34px;\n    height: 34px;\n    font-size: 13px;\n  }\n\n  .leave-request-item {\n    padding: 10px;\n  }\n\n  .no-attendance-box {\n    padding: 12px 14px;\n  }\n\n  .empty-state {\n    padding: 20px 0;\n    font-size: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
